import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useServiceType, ServiceType } from './useData';
import {
  moduleConfig,
  getInitialFormData,
  mapItemToFormData,
} from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<ServiceType>
      useData={useServiceType}
      config={{
        ...moduleConfig,
        getInitialFormData,
        mapItemToFormData,
      }}
    />
  );
};

export default Form;
